import ZendeskArticle from 'features/help/screens/ZendeskArticle';
import React from 'react';

export default function ZendeskArticlePage() {
  return <ZendeskArticle />;
}
